import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'app-manage-profiles-help',
    templateUrl: './manage-profiles-help.component.html',
    styleUrls: ['./manage-profiles-help.component.scss'],
    standalone: false
})
export class ManageProfilesHelpComponent implements OnInit {

  constructor(public languageService:LanguageService) { }

  ngOnInit(): void {
  }

}
